export default __webpack_public_path__ + "static/media/digit_trans.d09f868c.png";